module.exports = __webpack_public_path__ + "img/avatar-default.d9a13e95.svg";